import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Store} from "./models/Store";
import queryString from 'query-string';
import {getDevice} from "./utils/Util";
import {UAParser} from 'ua-parser-js';

(() => {

    // ブラウザ判定
    // mobile
    // ios : 12~
    // android : ?
    // pc
    // safari,chrome,edge,firefoxは行けるとして
    // ieはあかんね
    try {
        const ua = new UAParser(navigator.userAgent);

        console.info('[ index ] os=', ua.getOS());
        console.info('[ index ] engine=', ua.getEngine());
        const uaBrowser = ua.getBrowser();
        console.info('[ index ] browser=', uaBrowser);

        if (!uaBrowser.version) throw new Error();

        // Mobile Safari
        // 12以上

        if (uaBrowser.name === 'Mobile Safari') {
            const m = Number(uaBrowser.version.split('.')[0]);
            if (m < 12) throw new Error();
        }

        // Android
        // 9以上

        else if (ua.getOS().name === 'Android') {
            const v = ua.getOS().version;
            if (!v) throw new Error();
            const m = Number(v.split('.')[0]);
            if (m < 9) throw new Error();
        }

    } catch (e) {
        console.log('This browser is not supported.');
        document.body.classList.add('notSupported');
        // @ts-ignore
        document.querySelector('div.notSupported')!.style.display='block';
    }

    // パラメータ
    const qs = queryString.parse(window.location.search || '');

    const groupId = (qs.g) as string;
    console.log('groupId=', groupId);

    const isWorkshop = (qs.w || '0') === '1';

    // UA判定
    const device = getDevice();

    const config = {

        // 接続情報は開発用
        dev: {
            device,
            firebase: {
                apiKey: "AIzaSyDICALoPQo0dqE_9EAozYxu-0DnVU_Y0CQ",
                authDomain: "hikarino-mi-online-dev.firebaseapp.com",
                databaseURL: "https://hikarino-mi-online-dev.firebaseio.com",
                projectId: "hikarino-mi-online-dev",
                storageBucket: "hikarino-mi-online-dev.appspot.com",
                messagingSenderId: "878132117400",
                appId: "1:878132117400:web:e5180dfb59bf353713b5ed",
                measurementId: "G-C50SNNXXEV"
            },
            groupId: groupId,
            isWorkshop: isWorkshop,
            routerBasename:'smile-atelier-test-v3'
        },

        // // 接続情報は本番用
        // stg:{
        //     firebase:{
        //         apiKey: "AIzaSyBqUhxEkAFn2F4psbkQ0RtI2RZoAESTNSU",
        //         authDomain: "hikarino-mi.firebaseapp.com",
        //         databaseURL: "https://hikarino-mi.firebaseio.com",
        //         projectId: "hikarino-mi",
        //         storageBucket: "hikarino-mi.appspot.com",
        //         messagingSenderId: "606406306662",
        //         appId: "1:606406306662:web:f8c0b4d01f79e77b6eb6a7"
        //     },
        //     group:'stg'
        // },

        // 接続情報は本番用
        prd: {
            device,
            firebase: {
                apiKey: "AIzaSyBqUhxEkAFn2F4psbkQ0RtI2RZoAESTNSU",
                authDomain: "hikarino-mi.firebaseapp.com",
                databaseURL: "https://hikarino-mi.firebaseio.com",
                projectId: "hikarino-mi",
                storageBucket: "hikarino-mi.appspot.com",
                messagingSenderId: "606406306662",
                appId: "1:606406306662:web:f8c0b4d01f79e77b6eb6a7"
            },
            groupId: groupId,
            isWorkshop: isWorkshop,
            routerBasename:'smile-atelier'
        }
    };

    Store.initialize(config.prd);

    ReactDOM.render(
        <React.StrictMode>
            <App/>
        </React.StrictMode>,
        document.getElementById('root')
    );

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.unregister();

})();